import Vue from 'vue/dist/vue.esm.js';
import TurbolinksAdapter from 'vue-turbolinks'
import { inputChangeClass } from "../mixins/input_change_class";
import {globalMixin} from "../mixins/global";

Vue.use(TurbolinksAdapter)

document.addEventListener('turbolinks:load', () => {
  const element = document.getElementById("vue-lp-estate_properties-new") ||
    document.getElementById("vue-lp-estate_properties-create") ||
    document.getElementById("vue-lp-estate_properties-edit")
  if (element) {
    window.vueLoaded = true

    const app = new Vue({
      el: element,
      mixins: [inputChangeClass, globalMixin],
      components: {
      },
      data: () => {
        return {
          hasMentalDisorder: null,
          hasLoanArrears: null,
          hasGuaranteeCompanyArrears: null
        }
      },
      created() {
      },
      async mounted() {
      },
      methods: {
      }
    })
  }
})
